import { csx } from '@vtex/admin-ui'

const styles = {
  title: csx({
    display: 'block',
    marginBottom: '$space-4',
    marginTop: '$space-2',
  }),

  icon: csx({ marginTop: '$space-1' }),

  menu: csx({ marginTop: '-0.25rem' }),

  tagsList: csx({
    columnGap: '$space-2',
    rowGap: '$space-2',
  }),

  formPreview: csx({
    padding: '$space-5',
    border: '$neutral',
    borderRadius: 4,
    columnGap: '$space-5',
    cursor: 'pointer',
  }),

  tag: csx({
    maxWidth: '15rem',
    overflowX: 'clip',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'default',
  }),
}

export default styles
